import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "../../../Base/Select/Select";
import theme from "../../../../theme/theme";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import CustomAlertLabel from "../../../CustomAlertLabel/CustomAlertLabel";
import {
  transferGoal,
  resetSetTransferGoal,
  getIBKRDepositFundsURL,
  getIBKRTransferFundsURL,
  getIBKRStatementsURL,
} from "../../../../redux/actions";
import LoadingBar from "../../../LoadingBar/LoadingBar";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const TransferFundsWrapper = styled.div`
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header {
    .primaryText {
      font-size: 25px;
      font-weight: 800;
      @media (max-width: 480px) {
        text-align: center;
      }
    }

    .secondaryText {
      margin-top: 15px;
      font-size: 18px;
    }
  }

  .chooseGoalSection {
    margin-top: 50px;
    width: 70%;
  }

  .goalDetails {
    // margin-top: 50px;

    .primaryText {
      font-size: 15px;
      font-weight: 800;
    }

    .secondaryText {
      margin-top: 15px;
      font-size: 15px;

      .passwordInput {
        background: none;
        width: 100px;
        margin-left: 10px;
      }
      .show-hide-copy {
        margin-left: 20px;
        color: ${theme.colors.primaryStrong2X};
        cursor: pointer;
        display: flex;

        & p {
          margin-left: 5px;
          margin-block: 0;
          margin-top: -2px;
        }
      }
    }
  }

  .buttonSection {
    margin-top: 50px;
    @media (max-width: 480px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }

    .button {
      display: block;
      width: 70%;
      color: white;
      font-size: 15px;
      font-weight: 700;
      padding: 15px 0px;
      border: none;
      background: ${theme.colors.primaryStrong2X};
      border-radius: 4px;
      cursor: pointer;
    }

    .warningMessage {
      width: 70%;
      margin-top: 20px;
      font-size: 15px;
    }
  }

  .deepLinkButtonsContainer {
    margin-top: 10px;
    display: flex;
    width: 70%;
    gap: 10px;
    .deepLinkButton {
      width: 50%;
      border: none;
      background: ${theme.colors.primaryStrong2X};
      color: white;
      padding: 30px 0px;
      border-radius: 4px;
      cursor: pointer;
    }

    .deepLinkButtonDeactive {
      opacity: 0.2;
    }

    @media (max-width: 480px) {
      width: 100%;
    }
  }
`;

const TransferFunds = ({
  transferGoals,
  selectedGoalOnChange,
  selectedGoal,
  setActiveTab,
  goalIdToManage,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [goalStatus, setGoalStatus] = useState("");
  const [goalId, setGoalId] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [isCopyButtonNormal, setCopyButtonToNormal] = useState(true);
  const [isButtonsDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(isLoading);
  const [goalDropDownValue, setGoalDropdownValue] = useState("Choose Goal");

  const { transferGoalSet, userAccountDetails, newDashboardData } = useSelector(
    (state) => state.user
  );

  const handleTransferClick = () => {
    if (selectedGoal) {
      setCustomAlertMessage("");
      dispatch(transferGoal(selectedGoal));
      setActiveTab("manage");
      history.push("/strategy-screen/fromManage");
      setIsLoading(true);
    } else {
      setCustomAlertMessage("Please select a goal first");
    }
  };

  useEffect(() => {
    if (goalIdToManage) {
      let selectedGoalName =
        transferGoals.length > 0 &&
        transferGoals.filter((data) => data.goalId == goalIdToManage);
      if (selectedGoalName?.length > 0) {
        setGoalDropdownValue(selectedGoalName[0].goalTitle);
        selectedGoalOnChange(selectedGoalName[0].goalId);
        setUserName(
          transferGoals.filter((data) => data.goalId === goalIdToManage)[0]
            .ibUsername
        );
        setPassword(
          transferGoals.filter((data) => data.goalId === goalIdToManage)[0]
            .ibPassword
        );
        setGoalStatus(
          newDashboardData.filter(
            (data) => data.goalId === selectedGoalName[0].goalId
          )[0].ibAccountStatus
        );
        setGoalId(selectedGoalName[0].goalId);
      }
    }
  }, [goalIdToManage]);

  useEffect(() => {
    if (transferGoalSet) {
      window.open(transferGoalSet?.SIGNED_URL, "_blank");
      dispatch(resetSetTransferGoal());
      setIsLoading(false);
    }
  }, [transferGoalSet]);

  useEffect(() => {
    if (
      goalStatus === "Open" ||
      goalStatus === "Approved" ||
      goalStatus === "Funded"
    ) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [goalStatus]);

  const handleDepositFundsUrl = () => {
    setIsLoading(true);
    dispatch(getIBKRDepositFundsURL(goalId)).then((data) => {
      setIsLoading(false);
      window.open(data?.SIGNED_URL, "_blank");
    });
  };

  const handleTransferFundsUrl = () => {
    setIsLoading(true);
    dispatch(getIBKRTransferFundsURL(goalId)).then((data) => {
      setIsLoading(false);
      window.open(data?.SIGNED_URL, "_blank");
    });
  };

  const handleStatementsUrl = () => {
    setIsLoading(true);
    dispatch(getIBKRStatementsURL(goalId)).then((data) => {
      setIsLoading(false);
      window.open(data?.SIGNED_URL, "_blank");
    });
  };

  return (
    <TransferFundsWrapper>
      {(isLoaded || isLoading) && (
        <LoadingBar isLoading={isLoading} setIsLoaded={setIsLoaded} />
      )}
      <div className="header">
        <div className="primaryText">Manage Your Account</div>
        <div className="secondaryText">
          Make a deposit, withdrawal, or transfer between accounts.
        </div>
      </div>
      <div className="chooseGoalSection">
        <Select
          isMarginLeftRequired={true}
          blue
          placeholder={goalDropDownValue}
          value={goalDropDownValue}
          options={
            (transferGoals?.length &&
              transferGoals?.map((state) => ({
                label: `${state.goalTitle}`,
                value: `${state.goalId}`,
              }))) ||
            []
          }
          onChange={(value) => {
            selectedGoalOnChange(value);
            setUserName(
              transferGoals.filter((data) => data.goalId === value)[0]
                .ibUsername
            );
            setPassword(
              transferGoals.filter((data) => data.goalId === value)[0]
                .ibPassword
            );
            setGoalStatus(
              newDashboardData.filter((data) => data.goalId === value)[0]
                .ibAccountStatus
            );

            setGoalId(value);
          }}
        ></Select>
      </div>
      <div style={{ marginTop: "20px" }} className="secondaryText">
        <b>User ID:</b> {userName}
      </div>
      {isButtonsDisabled && password && (
        <div className="goalDetails">
          {/* <div className="primaryText">Goal Details</div> */}
          <div className="secondaryText">
            <div style={{ display: "flex" }}>
              <b>Temporary Password:</b>{" "}
              <div>
                <input
                  className="passwordInput"
                  type={passwordShown ? "text" : "password"}
                  value={password}
                />
              </div>
              <div
                className="show-hide-copy"
                onClick={() => setPasswordShown((prev) => !prev)}
              >
                {passwordShown ? (
                  <VisibilityOffIcon
                    fontSize="12px"
                    sx={{ cursor: "pointer" }}
                  />
                ) : (
                  <RemoveRedEyeIcon
                    fontSize="12px"
                    sx={{ cursor: "pointer" }}
                  />
                )}

                <p>{passwordShown ? "Hide" : "Show"} </p>
              </div>
              <div
                className="show-hide-copy"
                style={{
                  color: isCopyButtonNormal
                    ? theme.colors.primaryStrong2X
                    : "gray",
                }}
                onClick={() => {
                  if (!isCopyButtonNormal) return;
                  navigator.clipboard.writeText(password);
                  setCopyButtonToNormal(false);
                  setTimeout(() => {
                    setCopyButtonToNormal(true);
                  }, 1000);
                }}
              >
                <ContentCopyIcon fontSize="12px" sx={{ cursor: "pointer" }} />
                <p>{isCopyButtonNormal ? "Copy" : "Copied"}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      {isButtonsDisabled && (
        <div className="buttonSection">
          <button className="button" onClick={handleTransferClick}>
            Continue Application
          </button>
          <CustomAlertLabel message={customAlertMessage} />
          {/* <div className="warningMessage">
          *if this is your first transaction in this account, you will need to
          complete a one-time password reset to access these features
        </div> */}
        </div>
      )}
      <div className="deepLinkButtonsContainer">
        <button
          onClick={handleDepositFundsUrl}
          disabled={isButtonsDisabled}
          className={`deepLinkButton ${
            isButtonsDisabled && "deepLinkButtonDeactive"
          }`}
        >
          Deposit Funds
        </button>
        <button
          onClick={handleTransferFundsUrl}
          disabled={isButtonsDisabled}
          className={`deepLinkButton ${
            isButtonsDisabled && "deepLinkButtonDeactive"
          }`}
        >
          Transfer Funds
        </button>
      </div>
      <div className="deepLinkButtonsContainer">
        <button
          onClick={handleStatementsUrl}
          disabled={isButtonsDisabled}
          className={`deepLinkButton ${
            isButtonsDisabled && "deepLinkButtonDeactive"
          }`}
        >
          Statements
        </button>
        <button
          onClick={handleTransferClick}
          disabled={isButtonsDisabled}
          className={`deepLinkButton ${
            isButtonsDisabled && "deepLinkButtonDeactive"
          }`}
        >
          My Account
        </button>
      </div>
    </TransferFundsWrapper>
  );
};

export default TransferFunds;
